import React from "react";

export const formatINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN");

export const RISK = {
  "High Risk": { color: "#EF4444", bg: "#FEF2F2", ring: "#FECACA", label: "High Risk" },
  "Medium Risk": { color: "#D97706", bg: "#FFFBEB", ring: "#FDE68A", label: "Medium Risk" },
  "Watch": { color: "#0284C7", bg: "#F0F9FF", ring: "#BAE6FD", label: "Watch" },
  "Healthy": { color: "#059669", bg: "#ECFDF5", ring: "#A7F3D0", label: "Healthy" },
  "Recovered": { color: "#059669", bg: "#ECFDF5", ring: "#A7F3D0", label: "Recovered" },
  "Lost": { color: "#64748B", bg: "#F1F5F9", ring: "#CBD5E1", label: "Lost" },
};

export const riskStyle = (level) => RISK[level] || RISK["Healthy"];

export const initials = (name) =>
  name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export function RiskBadge({ level, score, size = "md" }) {
  const s = riskStyle(level);
  const pad = size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${pad}`}
      style={{ color: s.color, background: s.bg, border: `1px solid ${s.ring}` }}
      data-testid="risk-badge"
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.color }} />
      {s.label}
      {score !== undefined && <span className="opacity-70">· {score}</span>}
    </span>
  );
}

export function ScoreRing({ score, level, size = 132 }) {
  const s = riskStyle(level);
  const stroke = 11;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (score / 100) * c;
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#EEF1F6" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={s.color}
          strokeWidth={stroke} strokeLinecap="round" strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-4xl font-bold text-ink" style={{ lineHeight: 1 }}>{score}</span>
        <span className="text-[11px] font-semibold uppercase tracking-wide" style={{ color: s.color }}>
          {s.label}
        </span>
      </div>
    </div>
  );
}
